export default {
  // API_BASE_URL: 'http://localhost:3002/api',
  API_BASE_URL: 'https://smartshopcalc.com/api/api',
  // https://smartshopcalculator.com/api

};
